import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { buildWhatsAppLink } from "../../lib/whatsapp";

const HERO_BG =
  "https://images.unsplash.com/photo-1609421600950-6b6f18b7e674?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzaG9wcGluZyUyMGxvbmRvbnxlbnwwfHx8fDE3ODEzNDU0NTB8MA&ixlib=rb-4.1.0&q=85";

export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="relative w-full min-h-screen bg-[#0A0A0A] text-[#F8F5F0] overflow-hidden flex items-center"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${HERO_BG}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/65 to-[#0A0A0A]/95" />

      <div className="relative z-10 container-mps pt-32 pb-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-4xl"
        >
          <div className="overline text-[#C9A96E] mb-8">
            UK · Nigeria · Since 2011
          </div>
          <h1
            data-testid="hero-headline"
            className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.02] tracking-tight"
          >
            The private concierge for{" "}
            <span className="italic text-[#C9A96E]">UK shopping</span>,
            delivered to Nigeria.
          </h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-10 text-lg md:text-xl text-[#F8F5F0]/80 max-w-2xl leading-relaxed"
          >
            Selfridges to Lagos. Apple Regent Street to Abuja. Bond Street to Port Harcourt.
            We source it, verify it, and ship it — to any of Nigeria&apos;s 36 states in 7 to 10 days.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="mt-12 flex flex-col sm:flex-row gap-4"
          >
            <Link
              to="/order"
              data-testid="hero-cta-order"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#C9A96E] text-[#0A0A0A] text-sm uppercase tracking-[0.2em] hover:bg-[#A68A52] transition-colors hover-lift"
            >
              Start Your Order <ArrowUpRight size={16} />
            </Link>
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center gap-2 px-8 py-4 border border-[#C9A96E]/60 text-[#F8F5F0] text-sm uppercase tracking-[0.2em] hover:bg-[#C9A96E] hover:text-[#0A0A0A] transition-colors"
            >
              Speak to a Concierge
            </a>
          </motion.div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.6 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex items-center gap-3 text-xs uppercase tracking-[0.24em] text-[#F8F5F0]/60"
      >
        <span className="w-12 h-px bg-[#C9A96E]/60" />
        Scroll
        <span className="w-12 h-px bg-[#C9A96E]/60" />
      </motion.div>
    </section>
  );
}
